import ElementGroupsSelector from './element_groups_selector'
import connect from './connect'

export default connect(ElementGroupsSelector)
